import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

const savedLanguage = localStorage.getItem('preferLang') || 'en'; // 如果没有保存语言，默认使用 'en'
// 配置 i18next
i18n
    .use(HttpBackend) // 加载翻译文件
    .use(initReactI18next) // 将 i18next 和 React 绑定
    .init({
        fallbackLng: 'en', // 默认语言
        lng: savedLanguage, // 初始化语言
        debug: true, // 开启调试模式（开发时有用）
        keySeparator: false,
        nsSeparator: false,    // 命名空间分隔符
        interpolation: {
            escapeValue: false, // React 已经有 XSS 保护，无需额外处理
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json', // 翻译文件路径
        },
        react: {
            useSuspense: true, // 使用 suspense 模式
        },
    });

export default i18n;
